import { type ComponentPropsWithRef } from "react";
import { VideoSource } from "@/constants/media";
import { useGetVideoURL } from "../hooks";

type VideoProps = Omit<ComponentPropsWithRef<"video">, "src">;

export interface CoreVideoProps extends VideoProps {
  videoId: string;
}

const defaultOptions: VideoProps = {
  autoPlay: true,
  controls: true,
  playsInline: true,
};

export default function CoreVideo(props: CoreVideoProps) {
  const { videoId, ...videoProps } = props;
  const videoURL = useGetVideoURL(VideoSource.Core, videoId);

  return (
    <video {...defaultOptions} {...videoProps}>
      <source src={videoURL} type="video/mp4" />
    </video>
  );
}
